// extracted by mini-css-extract-plugin
export default {"AvatarName":"AvatarName_AvatarName__Y917p"};